export default __webpack_public_path__ + "static/blob13-886ffdce72b8578e6296050389e5d1b3.svg";